import Loading from './loading';

export default Loading;
export * from './loading';
